<template>
	<div class="notification-a">
		<div>
			<div>
				
				<h1 style="margin-bottom: 10px;">Purchase Successful!</h1>
				<p>You may check your receipts <a href="#">Here</a><br>Thank you for choosing Apollo!</p>
				<button class="button-type-e" style="font-size: 1.17em; width: 100%;" @click="endtransaction">Done!</button>
				
			</div>
		</div>
	</div>
</template>

<script>
	//NO current data
	export default{
		methods: {
			endtransaction: function(){
				this.$emit('endtransaction');
			}
		}
	}
</script>


// WEBPACK FOOTER //
// OrderNotification.vue?001454a9